'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardLoginsRequest(period, host, user) {
  this.KG = null;
  this.KF = null;
  this.DA = null;
  this.KG = period;
  this.KF = host;
  this.DA = user;
}
export { $c_Lpresto_types$DashboardLoginsRequest as $c_Lpresto_types$DashboardLoginsRequest };
$p = $c_Lpresto_types$DashboardLoginsRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardLoginsRequest;
/** @constructor */
function $h_Lpresto_types$DashboardLoginsRequest() {
}
export { $h_Lpresto_types$DashboardLoginsRequest as $h_Lpresto_types$DashboardLoginsRequest };
$h_Lpresto_types$DashboardLoginsRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$DashboardLoginsRequest)) {
    var x = this.KG;
    var x$2 = x$0.KG;
    if ((x === x$2)) {
      var x$3 = this.KF;
      var x$4 = x$0.KF;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.DA;
      var x$6 = x$0.DA;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "DashboardLoginsRequest";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.KG;
      break;
    }
    case 1: {
      return this.KF;
      break;
    }
    case 2: {
      return this.DA;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardLoginsRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jE)));
}
export { $isArrayOf_Lpresto_types$DashboardLoginsRequest as $isArrayOf_Lpresto_types$DashboardLoginsRequest };
var $d_Lpresto_types$DashboardLoginsRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardLoginsRequest, "presto.types$DashboardLoginsRequest", ({
  jE: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardLoginsRequest as $d_Lpresto_types$DashboardLoginsRequest };
//# sourceMappingURL=presto.types$-Dashboard-Logins-Request.js.map
